<template>
  <div class="bg">
    <a-card :title="$t('edit.editActionTitles.startAnimation')" :bordered="false">
      <a-row>
        <a-col :span="20">
          <a-form-model layout="vertical" ref="ruleForm" :form="form" :model="form">
            <a-form-model-item has-feedback>
              <a-radio-group v-for="(item, index) in $t('edit.editActionTitles.startAnimationArr')" :key="index"
                v-model="form.start_animation">
                <a-radio :value="index" >{{ item
                }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item>
              <a-button type="primary" @click="handleSubmit" >{{ $t('actionTitles.submit')}}</a-button>
              <a-button style="margin-left: 10px;" @click="handleCancel">{{ $t('actionTitles.cancel') }}</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["vrbase", "userInfo"]),
  },
  data() {
    return {
      form: {
        start_animation: 0,
      },
    };
  },
  created() {
    this.form.start_animation = this.vrbase.sets.start_animation || 0;
  },
  methods: {
    handleSubmit() {
      const vrbase = {
        ...this.vrbase,
        sets: { ...this.vrbase.sets, start_animation: this.form.start_animation },
      }
      this.$store
        .dispatch("saveVRBase", { vrbase, showLoading: true, })
        .then(() => {
          // this.$message.success(this.$t("message.saveSuccess"));
        });
      // console.log('start_animation', this.form.start_animation);
    },
    handleCancel() {
      this.form.start_animation = this.vrbase.sets.start_animation || 0;
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;

  .submitBtn {
    background-color: #7101ad;
    border-color: #7101ad;
  }
}
</style>
